import React, { Component } from 'react';
import LeadershipPrinciples from './LeadershipPrinciples'


class Header extends Component {
   render() {

      if (this.props.data) {
         var name = this.props.data.name;
         var occupation = this.props.data.occupation;
         var description = this.props.data.description;
         //var city= this.props.data.address.city;
         var profilepic = "images/" + this.props.data.image;
         var networks = this.props.data.social.map(function (network) {
            return <li key={network.name}><a href={network.url} target="_blank" rel="noopener noreferrer"><i className={network.className}></i></a></li>
         })
      }

      return (
         <header id="home">

            <nav id="nav-wrap">

               <a className="mobile-btn" href="#nav-wrap" title="Show navigation">Show navigation</a>
               <a className="mobile-btn" href="#home" title="Hide navigation">Hide navigation</a>

               <ul id="nav" className="nav">
                  <li className="current"><a className="smoothscroll" href="#home">Home</a></li>
                  <li><a className="smoothscroll" href="#about">About</a></li>
                  <li><a className="smoothscroll" href="#resume">Resume</a></li>
                  <li><a className="smoothscroll" href="#testimonials">Testimonials</a></li>
                  <li><a className="smoothscroll" href="#additional">Yoga Pictures</a></li>
                  <li><a className="smoothscroll" href="#contact">Contact</a></li>
               </ul>

            </nav>

            <div className="row banner">
               <div className="banner-text">
                  <h1 className="responsive-headline">I'm {name}.</h1>
                  <h3>A passionate yoga practioner and instructor!</h3>
                  <LeadershipPrinciples />
                  <img className="profile-pic" src={profilepic} alt="Guru's Profile Pic" width="175px" />
                  <h3><span>{occupation}</span>. <br />{description}.</h3>

                  <hr />
                  <ul className="social">
                     {networks}
                  </ul>
                  <ul className="social">
                     <a href="https://wa.me/+918762615502/?text=Hi%20Akshay,%20I%20am%20interested%20to%20learn%20yoga%20from%20you,%20please%20let%20me%20know%20the%20next%20steps!%20Thank%20You." target="_blank" rel="noopener noreferrer"><i className="fa fa-phone"></i></a>
                  </ul>
               </div>
            </div>

            <p className="scrolldown">
               <a className="smoothscroll" href="#about" ><i className="icon-down-circle"></i></a>
            </p>

         </header>
      );
   }
}

export default Header;
